import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

import { InactiveStepComponent } from './inactive-step/inactive-step.component';
import { StepperComponent } from './stepper.component';

@NgModule({
  declarations: [StepperComponent, InactiveStepComponent],
  imports: [CommonModule, MatProgressSpinnerModule, MatIconModule, MatTooltipModule],
  exports: [StepperComponent],
})
export class StepperModule {}
